import styled from "@emotion/styled";
import { units } from "../../../../types/units";
import { makeStyles } from "@material-ui/core/styles";
import { TableContainer } from "@material-ui/core";

export const ProductTableContainer = styled.div`
  border-radius: 10px;
  padding: 1rem;
  margin: 0 0 4rem;
  ${units({
    backgroundColor: "white",
  })};
`;

export const useProductTableStyles = makeStyles({
  table: {
    minWidth: 500,
  },
});

export const StyledTableContainer = styled(TableContainer)`
  overflow: visible;
`;
